{
  "version": "1.0",
  "view": "dvm-published",
  "route": "/dvm-published",

  "// dataSource": "computeOnOpen: every chart/table/input re-runs its own compute payload on open. publishStaticData: bake rows into the published widget (off = the published view reads them from compute only).",
  "dataSource": {
    "computeOnOpen": true,
    "publishStaticData": false
  },

  "// apiEndpoints": "Empty value = use the default shown in the comment. {dataset} is substituted at call time.",
  "apiEndpoints": {
    "baseUrl": "",
    "computeApi": "/components/compute",
    "filterApi": "/getData",
    "dashboardLayoutsApi": "/dashboard_layouts/dynamic_filter",
    "datasetRowsApi": "/{dataset}/dynamic_filter",
    "publishApi": ""
  },

  "// sidenav": "Left menu 'Published Dashboards': POST dashboardsApi with { email_id: [user] }, one menu item per row.",
  "sidenav": {
    "dashboardsApi": "/dashboard_layouts/dynamic_filter",
    "itemRoute": "/dynamic-dashboard/{slug}"
  }
}
